// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__fifL4","selected":"MenuItem_selected__h0SF8","iconOnly":"MenuItem_iconOnly__wJqUh","menuText":"MenuItem_menuText__9kMsX"};